import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const LeScoopSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$leScoopSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$leScoopSection' });

  return (
    <section id="hp-leScoop" className="hp-section leScoop-section leScoop">
      <div
        className="hp-banner desktop-only"
        data-event-name="bloc_interact"
        data-bloc-name={t('title')}
      >
        <Link href={tLink('leScoop')} className="clearfix reverse">
          <div className="stack left lem-bar">
            <h2>{t('title')}</h2>
            <p className="desktop-only">{t('copy')}</p>
            <span className="btn base-btn btn-main">
              <span>{tButton('shopNow')}</span>
            </span>
          </div>
          <div className="ctg-image">
            <picture>
              <source
                data-srcset="/images/homepage/leScoopSection/LEM-LeScoop-mob.jpg"
                media="(max-width: 768px)"
                srcSet="/images/homepage/leScoopSection/LEM-LeScoop-mob.jpg"
              />
              <img
                data-src="/images/homepage/leScoopSection/LEM-LeScoop.jpg"
                alt={t('alt')}
                src="/images/homepage/leScoopSection/LEM-LeScoop.jpg"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
                width="960"
                height="700"
              />
            </picture>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default LeScoopSection;
